<section id="startTrading" aria-labelledby="home-steps-title" class="pb-10 md:pb-40 home-start-section">
  <div class="custom-container">

    <h2 class="section-title mt-4 mb-7" id="home-steps-title"
      [innerHTML]="'home.home_start_title' | translate | safeHtml">
    </h2>
    <article class="steps-carousel">
      <owl-carousel-o [options]="customOptions()">
        <ng-template carouselSlide>
          <article class="steps-card-wrapper">
            <div class="steps-card">
              <div class="steps-card__header">

                <!-- Верхний блок: иконка + заголовок -->
                <div class="flex flex-col items-center text-center gap-4">
                  <img src="/images/icons/phone.svg" alt="Phone icon" class="w-12 h-12 sm:w-14 sm:h-14" />

                  <div class="font-['SfPro-Semibold',_sans-serif] text-2xl font-semibold relative w-full">
                    <span class="text-black">
                      {{ 'home.home_start_step_1_title' | translate }}
                    </span>
                    <span class="text-[#2b75db]">
                      {{ 'home.home_start_step_1_title_2' | translate }}
                    </span>
                  </div>

                  <!-- Контент (QR или изображение + кнопка) -->
                  <div class="flex flex-col items-center justify-center gap-2 w-full">
                    <!-- QR — десктоп -->
                    <qrcode [qrdata]="qrData()" [colorLight]="'#f3f7f8'" [width]="300" [errorCorrectionLevel]="'M'">
                    </qrcode>

                  </div>
                </div>
              </div>
            </div>
          </article>
        </ng-template>


        <ng-template carouselSlide>
          <article class="steps-card-wrapper">
            <div class="steps-card bg-[#2b75db]">
              <div class="steps-card__header">
                <div class="flex-1">
                  <p class="text-[#ffffff] text-center font-['SfPro-Semibold',_sans-serif] mb-4 text-2xl font-semibold">
                    {{ 'home.home_start_step_2_title' | translate }}</p>
                  <div class="flex justify-center">
                    <div class="bg-white/10 rounded-[100px] px-4 py-2.5 flex items-center justify-center">
                      <p class="text-white/80 font-['SfPro-Semibold',_sans-serif] text-sm font-semibold text-center">
                        {{ 'home.home_start_step_2_desc' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="steps-card__body px-4">
                <figure class="absolute left-1/2 -translate-x-1/2 w-[309px] h-auto">
                  <img ngSrc="/images/home/step-2.png" width="309" height="376" alt="Step 2 image">
                </figure>
              </div>
            </div>
          </article>
        </ng-template>

        <ng-template carouselSlide>
          <article class="steps-card-wrapper relative">
            <div class="steps-card">
              <div class="steps-card__header">
                <div class="flex-1">
                  <div
                    class="text-[#121212] text-center font-['SfPro-Semibold',_sans-serif] mb-3 text-2xl font-semibold whitespace-pre-line">
                    {{ 'home.home_start_step_3_title' | translate }}
                  </div>
                  <p
                    class="text-[rgba(18,18,18,0.50)] text-center font-['SfPro-Semibold',_sans-serif] mb-2 text-sm font-semibold">
                    {{ 'home.home_start_step_3_desc' | translate }}</p>
                </div>
              </div>

              <img src="/images/home/card.png" alt="Step 3 image"
                class="absolute top-[230px] left-[40px] w-[2200px] h-[320px] object-contain" />

            </div>
          </article>
        </ng-template>

        <ng-template carouselSlide>
          <article class="steps-card-wrapper">
            <div class="steps-card">

              <div class="flex-1 px-4 mt-6">
                <div
                  class="text-[#121212] text-center font-['SfPro-Semibold',_sans-serif] mb-4 text-2xl font-semibold whitespace-pre-line">
                  {{ 'home.home_start_step_4_title' | translate }}
                </div>
              </div>


              <div class="steps-card__body">
                <div class="flex justify-center">
                  <div class="bg-[rgba(18,18,18,0.05)] rounded-[100px] mb-6 inline-flex px-4 py-2.5">
                    <p
                      class="text-[rgba(18,18,18,0.50)] font-['SfPro-Semibold',_sans-serif] text-sm font-semibold whitespace-nowrap">
                      {{ 'home.home_start_step_4_subtitle' | translate }}
                    </p>
                  </div>
                </div>
                <article
                  class="bg-white rounded-[26px] w-full items-center justify-between flex-col gap-8 pt-2 mb-5 bg-[#f3f7f8]">
                  <article class="recommended-wallet">
                    <figure class="w-8 h-8">
                      <img ngSrc="/images/crypto/atomic-wallet.svg" width="32" height="32" alt="">
                    </figure>
                    <span
                      class="text-[#121212] text-left font-['SfPro-Semibold',_sans-serif] text-base font-semibold">Atomic
                      Wallet</span>
                  </article>
                  <div class="bg-[#f3f7f8] h-px w-3/4 mx-auto"></div>
                  <article class="recommended-wallet">
                    <figure class="w-8 h-8">
                      <img ngSrc="/images/crypto/gem-wallet.svg" width="32" height="32" alt="">
                    </figure>
                    <span class="text-[#121212] text-left font-['SfPro-Semibold',_sans-serif] text-base font-semibold">
                      Gem Wallet
                    </span>
                  </article>
                  <div class="bg-[#f3f7f8] h-px w-3/4 mx-auto"></div>
                  <article class="recommended-wallet">
                    <figure class="w-8 h-8">
                      <img ngSrc="/images/crypto/bitget-wallet.svg" width="32" height="32" alt="">
                    </figure>
                    <span
                      class="text-[#121212] text-left font-['SfPro-Semibold',_sans-serif] text-base font-semibold">Bitget
                      Wallet</span>
                  </article>
                  <div class="bg-[#f3f7f8] h-px w-3/4 mx-auto"></div>
                  <article class="recommended-wallet">
                    <figure class="w-8 h-8">
                      <img ngSrc="/images/crypto/tether.svg" width="32" height="32" alt="">
                    </figure>
                    <span
                      class="text-[#121212] text-left font-['SfPro-Semibold',_sans-serif] text-base font-semibold">Tether</span>
                  </article>
                </article>
              </div>
            </div>
          </article>
        </ng-template>

        <ng-template carouselSlide>
          <article class="steps-card-wrapper">
            <div class="steps-card bg-[#121212] bg-[url('/images/home/bg-cool.png')]">
              <div class="steps-card__header flex flex-col items-center">
                <!-- Заголовок -->
                <div
                  class="text-white text-center font-['SfPro-Semibold',_sans-serif] text-2xl font-semibold whitespace-pre-line">
                  {{ 'home.home_start_step_5_title' | translate }}
                </div>

                <!-- Подзаголовок -->
                <div class="flex justify-center w-full">
                  <div class="bg-[rgba(255,255,255,0.10)] rounded-[100px] mb-6 inline-flex px-4 py-2.5">
                    <p
                      class="text-[rgba(255,255,255,0.80)] font-['SfPro-Semibold',_sans-serif] text-sm font-semibold whitespace-nowrap">
                      {{ 'home.home_start_step_5_subtitle' | translate }}
                    </p>
                  </div>
                </div>

                <!-- Логотип -->
                <figure class="w-[300px] h-[300px] flex items-center justify-center">
                  <video class="w-full h-full object-cover" muted autoplay playsinline loop preload="auto"
                    src="videos/coin.webm"></video>
                </figure>
              </div>
            </div>
          </article>
        </ng-template>

        <ng-template carouselSlide>
          <article class="steps-card-wrapper">
            <div class="steps-card bg-[#2b75db] flex flex-col items-center justify-center gap-7">
              <figure class="w-full h-auto">
                <img ngSrc="/images/logos/logo-white.svg" width="300" height="78" alt="">
              </figure>
              <button type="button" class="rounded-full border border-white/10 px-5 h-14 flex items-center justify-center gap-1.5 relative
         transition-colors duration-200 hover:bg-white/10 hover:border-white/30" (click)="showAction()">
                @if (!account.isLoggedIn()) {

                <img src="/images/icons/registration-white.svg" alt="">

                <span class="text-[#ffffff] text-left font-['SfPro-Bold',_sans-serif] text-base font-bold">{{ 'register'
                  | translate }}</span>
                } @else {
                <span class="text-[#ffffff] text-left font-['SfPro-Bold',_sans-serif] text-base font-bold">{{ 'usdt_buy'
                  | translate }}</span>
                }
              </button>
            </div>
          </article>
        </ng-template>
      </owl-carousel-o>
    </article>
  </div>
</section>